import React from 'react'

export const MuteContactSvg = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.52513 3.11634C9.49849 2.28399 11 2.97564 11 4.25635V19.7427C11 21.0236 9.49818 21.7152 8.52489 20.8825L4 17.0114V6.98593L8.52513 3.11634Z"
      fill="#D7E0EE"
    />
    <path
      d="M15 8L23 16"
      stroke="#D7E0EE"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23 8L15 16"
      stroke="#D7E0EE"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0 8.5C0 7.67157 0.671573 7 1.5 7H4V17H1.5C0.671573 17 0 16.3284 0 15.5V8.5Z"
      fill="#D7E0EE"
    />
  </svg>
)
